import Main from "./components/Main/Main";



function App() {
  return (
    <div className="App">
      <Main/>
    </div>
  );
}

export default App;
